import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { EntityService } from './entity-service.service';

export abstract class BaseService<E, I> {
  service: EntityService<E, I>;
  http: HttpClient;

  constructor(base: string, http: HttpClient) {
    const urlNova = localStorage.getItem('urlNova');
    const baseUrl = urlNova ? urlNova : environment.paths.base;
    this.service = new EntityService<E, I>(`${baseUrl}/${base}`, http);
    this.http = http;
  }

  public createJsonHttpHeaders(): HttpHeaders {
    return this.service.createJsonHttpHeaders();
  }

  public path(path: string): string {
    return this.service.path(path);
  }
}
